/**
 * StayModule — admin OS surface for the /stay pillar.
 *
 * Wraps the universal request queue + a curated stays panel. Phase 1
 * just plumbs the routes so the team can see request volume and pick
 * signature hotels. Deeper curation (founder hand-list, neighbourhood
 * routing rules, price-tier override) lands in Phase 2.
 */
import React from "react";
import Placeholder from "@/pages/admin/os/Placeholder";

export default function StayModule() {
  return (
    <Placeholder
      title="Stay · Admin"
      phase="Phase 2"
      testid="os-modules-stay"
      description="Houses we know by name · curated rooms, late-checkout arrangements, and partner pairings. Member briefs landing here are visible in Operate → Requests."
      willInclude={[
        "Signature Hotels CRUD (founder hand-list per city)",
        "Late-checkout & arrival-pairing rules per partner",
        "Cross-pillar whisper rules (tables near hotel, etc.)",
        "Stay brief queue & confirmation pipeline",
      ]}
    />
  );
}
